<template>
  <div id="kostnadsbaserad-hyra">

<h1>Kostnadsbaserad Hyra</h1>
<p>En <strong>kostnadsbaserad hyra</strong> får inte vara påtagligt högre än summan av uthyrarens kapitalkostnad och driftkostnad.</p>


  </div>
</template>

<script>
export default {
  name: 'kostnadsbaserad-hyra'
}
</script>
<!-- styling for the component -->
<style>

</style>



// WEBPACK FOOTER //
// Kostnadsbaserad.vue?1b93610e